<template>
  <section id="top" class="hero">
    <div class="hero-glow" aria-hidden="true"></div>

    <div class="container hero-inner">
      <h1 class="hero-title reveal">
        达人连连
        <span class="hero-title-line">让达人建联不必等待</span>
      </h1>

      <p class="hero-sub reveal">
        专注抖音 / 快手 / 小红书自动化运营，模拟人工完成达人邀约、筛选与报名，
        节省 80% 人力成本，建联效率提升 300%。
      </p>

      <div class="hero-cta reveal">
        <div class="dl-wrap" @mouseenter="open = true" @mouseleave="open = false">
          <button class="btn btn--dark btn--lg" @click="open = !open" :aria-expanded="open">
            <svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 3v12" /><path d="m7 11 5 5 5-5" /><path d="M5 21h14" />
            </svg>
            下载客户端
            <svg class="chev" :class="{ 'is-up': open }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="m6 9 6 6 6-6" />
            </svg>
          </button>

          <transition name="drop">
            <div v-show="open" class="dl-menu">
              <button class="dl-item" @click="download('normal')">
                <span class="dl-item-name">会员版下载</span>
                <span class="dl-item-desc">登录并购买会员使用</span>
              </button>
              <button class="dl-item" @click="download('kami')">
                <span class="dl-item-name">卡密版下载</span>
                <span class="dl-item-desc">使用卡密授权激活</span>
              </button>
            </div>
          </transition>
        </div>

        <a class="btn btn--ghost btn--lg" href="#features" @click.prevent="scrollTo('features')">了解功能</a>
      </div>

      <p class="hero-note reveal">支持 Windows · 需配合谷歌浏览器（Chrome）使用 · 多端数据实时同步</p>
    </div>
  </section>
</template>

<script>
import { downloadLatestApp } from "@/utils/download";

export default {
  name: "HeroSection",
  data() {
    return { open: false };
  },
  methods: {
    download(type) {
      this.open = false;
      downloadLatestApp(type);
    },
    scrollTo(id) {
      const el = document.getElementById(id);
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }
};
</script>

<style scoped>
.hero {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  min-height: 100vh;
  min-height: 100svh;
  padding: calc(var(--header-h) + 32px) 0 48px;
  background: var(--bg);
}

.hero-glow {
  position: absolute;
  top: -220px;
  left: 50%;
  width: 900px;
  height: 620px;
  transform: translateX(-50%);
  background: radial-gradient(
    ellipse at center,
    rgba(31, 162, 240, 0.13) 0%,
    rgba(97, 185, 46, 0.07) 42%,
    rgba(255, 255, 255, 0) 70%
  );
  pointer-events: none;
}

.hero-inner {
  position: relative;
  width: 100%;
  text-align: center;
}

.hero-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: var(--text-1);
  font-size: clamp(38px, 5.6vw, 68px);
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.03em;
}

.hero-title-line {
  background: linear-gradient(96deg, #1fa2f0 0%, #1fa2f0 38%, #61b92e 92%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.hero-sub {
  max-width: 720px;
  margin: 26px auto 0;
  color: var(--text-2);
  font-size: 17px;
  line-height: 1.8;
}

.hero-cta {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 14px;
  margin-top: 40px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: var(--r-full);
  font-weight: 600;
  white-space: nowrap;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease,
    border-color 0.18s ease, color 0.18s ease;
}

.btn--lg {
  height: 52px;
  padding: 0 30px;
  font-size: 16px;
}

.btn--dark {
  background: var(--ink);
  color: #fff;
  box-shadow: 0 6px 20px rgba(17, 24, 39, 0.16);
}

.btn--dark:hover {
  background: #000;
  box-shadow: 0 12px 30px rgba(17, 24, 39, 0.24);
  transform: translateY(-1px);
}

.btn--ghost {
  background: #fff;
  color: var(--text-1);
  border: 1px solid var(--border-strong);
}

.btn--ghost:hover {
  border-color: rgba(17, 24, 39, 0.28);
  background: #fff;
  transform: translateY(-1px);
}

.ico {
  width: 18px;
  height: 18px;
}

.chev {
  width: 15px;
  height: 15px;
  opacity: 0.7;
  transition: transform 0.2s ease;
}

.chev.is-up {
  transform: rotate(180deg);
}

/* 下拉 */
.dl-wrap {
  position: relative;
}

.dl-menu {
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%);
  width: 250px;
  padding: 6px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-lg);
  text-align: left;
  z-index: 20;
}

.dl-menu::before {
  content: "";
  position: absolute;
  top: -14px;
  left: 0;
  right: 0;
  height: 14px;
}

.dl-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: 11px 14px;
  border-radius: var(--r-md);
  transition: background 0.16s ease;
}

.dl-item:hover {
  background: var(--bg-soft);
}

.dl-item-name {
  color: var(--text-1);
  font-size: 14.5px;
  font-weight: 600;
}

.dl-item-desc {
  color: var(--text-3);
  font-size: 12.5px;
}

.drop-enter-active,
.drop-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.drop-enter-from,
.drop-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-6px);
}

.hero-note {
  margin-top: 22px;
  color: var(--text-3);
  font-size: 13px;
  letter-spacing: 0.01em;
}

@media (max-width: 768px) {
  .hero {
    padding: calc(var(--header-h) + 28px) 0 40px;
  }
  .hero-sub {
    margin-top: 18px;
    font-size: 15px;
  }
  .hero-cta {
    flex-direction: column;
    align-items: stretch;
    max-width: 320px;
    margin: 30px auto 0;
    gap: 10px;
  }
  .btn--lg {
    width: 100%;
    height: 48px;
    font-size: 15px;
  }
  .dl-menu {
    left: 0;
    transform: none;
  }
  .drop-enter-from,
  .drop-leave-to {
    transform: translateY(-6px);
  }
}
/* 矮屏（笔记本 / 横屏）下收紧留白，避免内容溢出首屏 */
@media (max-height: 760px) and (min-width: 769px) {
  .hero {
    padding: calc(var(--header-h) + 18px) 0 26px;
  }
  .hero-sub {
    margin-top: 16px;
    font-size: 16px;
  }
  .hero-cta {
    margin-top: 26px;
  }
  .hero-note {
    margin-top: 15px;
  }
}
</style>
